/**
 * The Disposable contract.
 *
 * Implemented by objects that can free internal resources.
 *
 * @interface
 */

export class Disposable {

	/**
	 * Frees internal resources.
	 */

	dispose() {}

}



//////////////////
// WEBPACK FOOTER
// /opt/build/repo/node_modules/postprocessing/src/core/Disposable.js
// module id = 138
// module chunks = 0